const tables = [
  {
    name: "Supplier",
  },
  {
    name: "Total Payable",
  },
  {
    name: "Outstanding",
  },
  {
    name: "0-30 Days",
  },
  {
    name: "31-60 Days",
  },
  {
    name: "61-90 Days",
  },
  {
    name: "90+ Days",
  },
  {
    name: "PO Count",
  },
  {
    name: "Action",
  },
];

export default tables;
